import { useEffect, useState } from "react";

/**
 * Returns a value that only updates after `delayMs` milliseconds of stability.
 * Useful for typeahead inputs to avoid firing a request on every keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);
  return debounced;
}
